<!-- =========================================================================================
    File Name: TheFooter.vue
    Description: Footer component
    Component Name: TheFooter
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <footer v-if="$route.name != 'QuizTaskViewer' && $route.name != 'VideoViewer' && $route.name != 'UploadViewer'" id="footerGlobal" class="the-footer flex-wrap justify-between" :class="classes">
        <span class="main-footer-text">COPYRIGHT @ {{ new Date().getFullYear() }} Lateral Scaffolding | Powered by <a href="https://DigiCentral.co.za" style="color: #52b75d" target="_blank" rel="nofollow">DigiCentral.co.za</a>. All rights Reserved</span>
    </footer>
</template>

<script>
export default {
    name: "the-footer",
    props: {
        classes: {
            type: String,
        },
    }
}
</script>
